import React from 'react'

const SuperProfile = () => {
    return (
        <div>

        </div>
    )
}

export default SuperProfile
